import { useTranslation } from "react-i18next";
import { generatePath, useHistory } from "react-router-dom";
import routing from "routing";
import type { FolderDetails } from "src/components/Folders/types";
import { ShortLimitedAccess } from "src/components/NewComponents/LimitedAccess";
import { hasLimitedAccess } from "src/helpers/getPermissions";
import { useCreateFolder } from "src/hooks/useFolders";
import FolderIcon from "src/images/Icons/newIcons/folder.svg";
import { ModalMaxWidth } from "src/types/enums";

import { Modal, ModalTitle } from "./Components/ModalsComponents";
import { FolderModal } from "./FolderModal";

interface CreateFolderModalProps {
	onClose: () => void;
}

export const CreateFolderModal = ({ onClose }: CreateFolderModalProps) => {
	const { t } = useTranslation();
	const history = useHistory();
	const { mutateAsync: createFolder, isPending: isLoading } = useCreateFolder();

	if (hasLimitedAccess()) {
		return (
			<Modal onClose={onClose} maxWidth={ModalMaxWidth.sm}>
				<ModalTitle
					title={t("modals.createFolder.title", "Utwórz nowy folder")}
					Icon={FolderIcon}
				/>
				<ShortLimitedAccess />
			</Modal>
		);
	}

	const handleSubmit = async (name: string, details: FolderDetails | null) => {
		const { id } = await createFolder({ name, details });
		history.push(generatePath(routing.paths.folder, { id }));
	};

	return (
		<FolderModal
			onClose={onClose}
			onSubmit={handleSubmit}
			isLoading={isLoading}
			title={t("modals.createFolder.title", "Utwórz nowy folder")}
			submitLabel={t("modals.createFolder.submit", "Utwórz folder")}
		/>
	);
};
